export const BASE_NAME = '/freelancers';

export const Routes = {
    Root: '/:username',
};
